import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PricingTable = ({ packages, onSelectPackage }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(price);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Hizmet Paketleri</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {packages?.map((pkg) => (
          <div
            key={pkg?.id}
            className={`
              relative p-6 rounded-lg border-2 transition-smooth hover:shadow-elevation-2
              ${pkg?.popular 
                ? 'border-primary bg-primary/5' :'border-border bg-background'
              }
            `}
          >
            {pkg?.popular && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-primary text-primary-foreground rounded-full text-xs font-medium">
                En Popüler
              </div>
            )}

            <div className="text-center mb-4">
              <div className={`
                w-12 h-12 mx-auto mb-3 rounded-full flex items-center justify-center
                ${pkg?.popular ? 'bg-primary/20' : 'bg-muted'}
              `}>
                <Icon 
                  name={pkg?.icon} 
                  size={24} 
                  color={pkg?.popular ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
                />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-1">{pkg?.name}</h3>
              <p className="text-sm text-muted-foreground">{pkg?.description}</p>
            </div>

            <div className="text-center mb-4 pb-4 border-b border-border">
              <p className="text-3xl font-bold text-foreground">{formatPrice(pkg?.price)}</p>
              <p className="text-sm text-muted-foreground mt-1">{pkg?.deliveryTime} gün teslimat</p>
            </div>

            <ul className="space-y-3 mb-6">
              {pkg?.features?.map((feature, index) => (
                <li key={index} className="flex items-start gap-2">
                  <Icon name="CheckCircle" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-foreground">{feature}</span>
                </li>
              ))}
            </ul>

            <Button
              variant={pkg?.popular ? 'default' : 'outline'}
              fullWidth
              onClick={() => onSelectPackage(pkg)}
            >
              Paketi Seç
            </Button>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">Özel Paket İsteği</p>
            <p className="text-sm text-muted-foreground">
              İhtiyaçlarınıza özel bir paket oluşturmak için influencer ile doğrudan iletişime geçebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingTable;